//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {},
  data () {
    return {}
  },
  created () { },
  mounted () { },
  methods: {
    rule () {
      this.$router.push({ name: 'diceactivityRule' })
    }
  }
}
